import { Component, Input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import type { LeafPopover } from '@cigna/leaf-web/lib/wc';
import '@cigna/leaf-web/lib/wc/components/popover/popover';

@Component({
  selector: 'cigna-leaf-popover',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <leaf-popover
      [heading]="heading"
      [position]="position"
      [isVisibleOnScroll]="isVisibleOnScroll"
      [isDynamic]="isDynamic"
      [isActiveDynamic]="isActiveDynamic"
      [isActive]="isActive"
      ><ng-content></ng-content
    ></leaf-popover>
  `,
})
export class CignaLeafPopoverComponent {
  @Input() heading: LeafPopover['heading'];
  @Input() position: LeafPopover['position'];
  @Input() isVisibleOnScroll: LeafPopover['isVisibleOnScroll'];
  @Input() isDynamic: LeafPopover['isDynamic'];
  @Input() isActiveDynamic: LeafPopover['isActiveDynamic'];
  @Input() isActive: LeafPopover['isActive'];
}
